module.exports = __webpack_public_path__ + "img/sysmo-icon-v3.db379073.png";